<template>
  <form-block
    :title="tr('Tracking')"
    :description="tr('You can track datasets of events that include conversions your ad may have driven. By default, the system tracks the dataset associated with the conversion selected for your ad account.')"
    :disabled="disabled"
  >
    <div :class="[ 'flex flex-col gap-2', appTrackingDisabled ? 'opacity-50' : '' ]">
      <label :class="[ 'flex w-fit items-center gap-2 text-sm text-foreground', appTrackingDisabled ? 'cursor-not-allowed' : 'cursor-pointer' ]">
        <ui-checkbox
          :model-value="appEventsChecked"
          :disabled="appTrackingDisabled"
          @update:model-value="(value) => appEventsChecked = value"
        />
        {{ tr('App events') }}
      </label>
      <select-field
        v-if="appEventsChecked"
        v-model="entity.settings.tracking_advertisable_application_id"
        :options="advertisableApplications"
        :reduce="(obj) => obj.id"
        :placeholder="tr('Select an app')"
        label="name"
        :disabled="appTrackingDisabled"
      />
    </div>

    <div :class="[ 'flex flex-col gap-2', hasPixels ? '' : 'opacity-50' ]">
      <label :class="[ 'flex w-fit items-center gap-2 text-sm text-foreground', hasPixels ? 'cursor-pointer' : 'cursor-not-allowed' ]">
        <ui-checkbox
          :model-value="websiteEventsChecked"
          :disabled="!hasPixels"
          @update:model-value="(value) => websiteEventsChecked = value"
        />
        {{ tr('Website events') }}
      </label>
      <select-field
        v-if="websiteEventsChecked"
        v-model="entity.settings.tracking_pixel_id"
        :options="pixels"
        :reduce="(obj) => obj.id"
        :placeholder="tr('Select a pixel')"
        label="name"
        :disabled="disabled || !hasPixels"
      />
    </div>
  </form-block>
</template>

<script>
import RuleFormBlockMixin from '@/mixins/RuleForm/Block.js';
import SelectField from '@/ui/components/SelectField.vue';

export default {
  name: 'TrackingBlock',
  components: {
    SelectField,
  },
  mixins: [ RuleFormBlockMixin ],
  data() {
    return {
      websiteEventsChecked: !!this.entity.settings.tracking_pixel_id,
      appEventsChecked: !!this.entity.settings.tracking_advertisable_application_id,
    };
  },
  computed: {
    advertisableApplications() {
      return this.entity.selectedAdAccount.advertisable_applications || [];
    },
    pixels() {
      return this.entity.selectedAdAccount.pixels || [];
    },
    hasAdvertisableApplications() {
      return this.advertisableApplications.length > 0;
    },
    hasPixels() {
      return this.pixels.length > 0;
    },
    appTrackingDisabled() {
      return this.disabled || !this.hasAdvertisableApplications || this.entity.isAppPromo;
    },
  },
  watch: {
    websiteEventsChecked(val) {
      if (!val) {
        this.entity.settings.tracking_pixel_id = null;
      }
    },
    appEventsChecked(val) {
      if (!val) {
        this.entity.settings.tracking_advertisable_application_id = null;
      }
    },
  },
  created() {
    if (this.entity.isAppPromo) {
      this.appEventsChecked = true;
      this.entity.settings.tracking_advertisable_application_id = this.entity.settings.adset_conversion_app_id;
    }
  },
  methods: {
    validate() {
      if (this.websiteEventsChecked && !this.entity.settings.tracking_pixel_id) {
        this.error('When a website is used as an event tracking location, a Pixel must be added!');
        return false;
      }
      if (this.appEventsChecked && !this.entity.settings.tracking_advertisable_application_id) {
        this.error('When an app is used as an event tracking location, an App must be added!');
        return false;
      }

      return true;
    },
  },
};
</script>
